import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import GlobalStyle from '../../../styles/GlobalStyle';
import Container from '@material-ui/core/Container';
import Avatar from '@material-ui/core/Avatar';
import LogoPoweredbyImg from '../../../assets/images/blackbelthelp-logo.png';

class Footer extends React.Component {
    
    render() {
      const { classes } = this.props;
      return (
        <forgot-container>
        <Container className={classes.footerContainer}  component="div" style={{width:'30%',margin:'0 auto'}}>
          <footer-header variant="h2" align="left" component="h2"  className={classes.mainHeader}>Powered by <Avatar alt="Footer Logo" src={LogoPoweredbyImg}></Avatar></footer-header>
        </Container>
        </forgot-container>
      )
    }
}

export default withStyles(GlobalStyle)(Footer);